import type { Observable } from '@spotar/runtime';
import {
  buildCmsAiRequestHeaders,
  cmsApiUrl,
  getAiRequestSpotId,
  readCmsApiErrorMessage,
  resolveCmsAssetRefUrl
} from '../cms-ai-api';

const DEFAULT_VOICE = 'ukONT0PiO5smfFLmTj12';

export async function runTextToSpeechImplementation(data: {
  text?: string;
  language?: string;
  voice?: string;
  audio: Observable<unknown>;
}) {
  const text = typeof data.text === 'string' ? data.text.trim() : '';
  const language =
    typeof data.language === 'string' && data.language.trim() !== ''
      ? data.language.trim()
      : 'de';
  const voice =
    typeof data.voice === 'string' && data.voice.trim() !== ''
      ? data.voice.trim()
      : DEFAULT_VOICE;

  if (!text) {
    throw new Error('Text to speech: missing text input');
  }

  const spotId = getAiRequestSpotId();
  if (!spotId) {
    throw new Error('Text to speech: missing spotId context');
  }

  const response = await fetch(cmsApiUrl('/api/ai/tts'), {
    method: 'POST',
    headers: buildCmsAiRequestHeaders(),
    body: JSON.stringify({ spotId, text, language, voice })
  });

  if (!response.ok) {
    const detail = await readCmsApiErrorMessage(response);
    throw new Error(`Text to speech failed: ${response.status} (${detail})`);
  }

  const payload = (await response.json()) as {
    id?: string;
    type?: string;
    url?: string;
    filename?: string;
    size?: number;
  };

  if (!payload.url || typeof payload.url !== 'string') {
    throw new Error('Text to speech: missing audio url in response');
  }

  const resolvedUrl = resolveCmsAssetRefUrl(payload.url) ?? payload.url;

  
    data.audio.value = {
      id: typeof payload.id === 'string' ? payload.id : '',
      type: 'audio' as const,
    url: resolvedUrl,
      filename: typeof payload.filename === 'string' ? payload.filename : undefined,
      size: typeof payload.size === 'number' ? payload.size : undefined
    }
  
}
